import { Navigate } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
import { selectIsAuthenticated } from "../store/slices/authSlice";

export default function ReverseProtectedRoute({ children }) {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  // If user is authenticated, redirect to admin dashboard
  if (isAuthenticated) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
}
